<template>
  <div
    class="ks-overlay ks-static ks-static-subscription"
    ref="scrollContainer"
    v-on:scroll.passive="$root.measure($event, $refs.scrollTarget)"
  >
    <div class="ks-overlay-hitarea" v-on:mouseover="$root.hitareaActive = true" v-on:mouseout="$root.hitareaActive = false"  v-on:click="$router.push({name:'home'})"/>
    <div class="ks-overlay-container" ref="scrollTarget" :class="{'ks-overlay-container-top': $root.scrollOffset === false}">
      <Closetag v-bind:force="'home'" v-bind:hasnav="true"/>
      <div class="ks-static-entry">

        <div class="ks-overlay-container-head">
            <h1>Anmeldungen</h1>
        </div>
        <template v-if="mailresponse">
            <div class="ks-roundbox">
                <div class="ks-overlay-container-small">
                    <div class="ks-static-subscription-title">
                        <h1>
                            🔔
                            <span>
                                <p  v-html="mailresponse.Message"/>
                            </span>
                        </h1>
                    </div>
                </div>
            </div>
        </template>
        <template v-else v-for="project in projects">
            <div class="ks-roundbox" v-bind:key="project._id">
                <div class="ks-overlay-container-small">
                    <div class="ks-static-subscription-title">
                        <p class="ks-static-subscription-title-left">
                        Anmeldeschluss
                        </p>
                        <p class="ks-static-subscription-title-right">
                        {{project.Anmeldeschluss | yearformat('Tag/Monat/Jahr')}}
                        </p>
                        <h1>
                            🔔
                            <span>
                                <p v-html="project.Veranstaltung"/>
                            </span>
                        </h1>
                    </div>
                </div>
                <div v-if="formResponse[project._id] !== undefined &&  formResponse[project._id].Error === false" class="ks-overlay-container-small">
                    <p  v-html="formResponse[project._id].Message"/>
                </div>
                <template v-else>
                    <div class="ks-overlay-container-small" v-html="project.Text"/>
                    <div class="ks-overlay-container-small">
                        <div v-if="formResponse[project._id] !== undefined && formResponse[project._id].Error === true" style="color: red; margin: var(--pd1) 0;">
                            <p  v-html="formResponse[project._id].Message"/>
                        </div>
                        <form class="submission" method="post" v-on:submit.prevent="post(project._id, 'Anmelden')">
                            <label v-for="(field, fkey) in project.Felder" v-bind:key="`${fkey}-${project._id}`">
                                <span v-html="field"/>
                                <input v-model="formData[project._id][field]" :required="field=='Telefon'?false:true" :type="field=='E-Mail'?'email':(field=='PLZ'?'number':'text')" :name="field">
                            </label>
                            <div class="submission-buttons">
                                <input class="ks-blue-button" type="submit" value="Anmelden"  v-on:click.prevent="post(project._id, 'Anmelden')"/>
                                <input class="ks-red-button" type="submit" value="Abmelden"  v-on:click.prevent="post(project._id, 'Abmelden')"/>
                            </div>
                        </form>
                    </div>
                </template>
            </div>
        </template>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable */

import Closetag     from '../components/Closetag.vue'
import Footer       from '../components/Footer.vue'

export default {
    name: 'Subscription',
    components: {
        Closetag,
        Footer
    },
    data () {
        return {
            projects: false,
            mailresponse: false,
            formData: {},
            formResponse: {},
        }
    },
    async mounted() {
        if (this.$route.query.e && this.$route.query.h && this.$route.query.id) {
            let response = await this.$http.post('/subscriptions', this.$route.query);
            this.mailresponse = response.data;
        }
        else {
            this.$http(`/subscriptions`).then((d) => {
                this.projects = d.data
                this.projects.forEach(p => {
                    if (p.Felder.indexOf('E-Mail') === -1) {
                        p.Felder.push('E-Mail')
                    }
                    this.formData[p._id] = {
                        _id: p._id,
                        _name: p._name,
                        Veranstaltung: p.Veranstaltung,                    
                    }            
                });
            });
        }
    },
    beforeRouteLeave (to, from, next) {
		console.log('leave');
		if (to.name !== 'subscription') {
			this.$root.scrollOffset = false;
			this.$root.$emit('overlay:close', true);
			this.$root.applyMeta();
		}
		next();
    },
    methods: {
        async post (id, mode) {
            console.log(this.formData[id])
            mode = mode || 'Anmelden'
            this.formData[id]._action = mode
            let response = await this.$http.post('/subscriptions', this.formData[id]);
            this.$set(this.formResponse, id, response.data)
            console.log(this.formResponse)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

    @import '../main';

    .ks-static {
        &-subscription {
			.ks-roundbox {
                padding-top: 0;
            }
            .ks-overlay-container-gallery {
                background: $ks-blue;
                color: white;
            }
            .ks-overlay-container-small {
                background: transparent;
            }
            .ks-overlay-container {
                color: $ks-blue;
            }
            .ks-overlay-container-dark,
            .ks-overlay-container-head,
            .ks-overlay-container-stickyhead {
                background: transparent;
            }
            .ks-round-button {
                span {
                color: $ks-blue;
                }
                background: white;
                border-color: $ks-blue;
                color: $ks-blue;
                &-active {
                background: $ks-blue;
                border-color: $ks-blue;
                span {
                    color: white;
                }
                }
            }
            .submission {
                margin: var(--pd1) 0;
                &-buttons {
                    display: flex;
                    align-content: center;
                }
                label {
                    padding: var(--pd1) 0;
                    width: 100%;
                    @include mediumfont();
                    display: flex;
                    span {
                        display: inline-block;
                        width: 20%;
                    }
                    input {
                        width: 80%;
                        appearance: none;
                        border: none;
                        background: transparent;
                        border-bottom: 1px solid $ks-blue;
                        font: inherit;
                        color: $ks-blue;
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                        &:focus {
                            outline: none;
                        }
                    }
                }
                input[type=submit] {
                    margin: auto;
                    text-align: center;
                    appearance: none;
                    display: block;
                    font: inherit;
                    @include mediumfont;
                    margin-top: var(--pd3);
                    padding: 0 var(--pd1);
                }
            }
            &-title {
                position: relative;
                padding-top: var(--pd1);
                margin: auto;
                &-left,
                &-right {
                    position: absolute;
                    top: var(--pd2);
                    padding: 0;                
                }
                &-left {
                    left: 0;
                }
                &-right {
                    right: 0;
                }
                &-body {
                    p {
                        padding: 0;
                    }
                }
                h1 {
                    text-align: center;
                    padding: var(--pd3) 0 0 0;
                    p {
                        padding: 0;
                        margin-top: var(--pd1);
                        @include largefont();                        
                    }
                }
                &-top {
                    h1 {
                        padding: var(--pd1) 0 0 0;
                    }
                }
            }
        }
    }



</style>



// WEBPACK FOOTER //
// src/components/Subscription.vue